<template>
  <!-- Panel on the edge of element which trigger bubble with comment -->
  <div
    class="CommentTooltip bg-white shadow-lg absolute right-4 lg:right-0 top-4 text-bc-blue flex items-center justify-center cursor-pointer transform md:translate-x-10 sm:translate-x-2 rounded z-30 p-2 pb-1 Comments"
    :class="{ NoComments: totalComments === 0 }"
    @click="toggleComments(), focusTextarea()"
  >
    <aw-icon icon="comment-tooltip" class="w-7 h-7 " />
    <!--
    <aw-icon
      icon="comment-add"
      class="w-7 h-7 ml-1 text-green-500 "
    />
    -->

    <span
      title="Comments"
      class="absolute bg-bc-blue text-white rounded-full text-xxs top-0 right-0 transform translate-x-2.5 -translate-y-2.5 w-4 h-4 text-center"
      >{{ totalGroups }}</span
    >
  </div>

  <!-- Comment wrapper -->
  <div class="TooltipBubbleWrapper z-40" v-if="showComments">
    <transition name="bounce">
      <div v-if="showComments" ref="commentRef">
        <document-comment-group
          v-for="(group, index) in listGroups"
          :key="index"
          :element="element"
          :document="document"
          :position="parseInt(index)"
          v-model="comments"
          :comments="group"
        />
        <div class="TooltipBubble text-left">
          <div class="mt-2">
            <textarea
              :placeholder="$t('Your comment')"
              class="w-full border-gray-400 rounded text-sm"
              v-model="newCommentText"
              ref="newCommentTextRef"
              autofocus
            ></textarea>
          </div>
          <div class="mt-1 -mx-4 h-0.25"></div>
          <div class="flex items-center">
            <a
              href="#"
              class="btn btn-primary btn-xs mr-2"
              @click.stop.prevent="addComment"
              >{{ $t('Add comment') }}</a
            >
            <a
              href="#"
              class="text -right leading-snug text-xs text-gray-400 flex-grow text-right"
              @click.prevent.stop="showDone = false"
              v-show="showDone && totalDoneGroups"
              >{{ $t('Hide done') }}</a
            >
            <a
              href="#"
              class="text -right leading-snug text-xs text-bc-blue flex-grow text-right"
              @click.prevent.stop="showDone = true"
              v-show="!showDone && totalDoneGroups"
              >{{
                $t('Show done (%totalDoneGroups%x)', { totalDoneGroups })
              }}</a
            >
          </div>
        </div>
      </div>
    </transition>
  </div>
  <!-- //.TooltipBubbleWrapper -->
</template>

<script>
import { DocumentApi } from '../../test-api/index.ts'
const documentApi = new DocumentApi({}, '/api/v2')
import { ref, watch } from 'vue'
import { onClickOutside } from '@vueuse/core'
import handleApiError from '../../utils/handleApiError'

export default {
  emits: ['update:modelValue', 'comment-toggle'],
  props: {
    modelValue: Object,
    element: Object,
    document: Object
  },

  setup(props, context) {
    const commentRef = ref(null)
    const showComments = ref(false)

    onClickOutside(commentRef, () => {
      showComments.value = false
    })

    const toggleComments = () => {
      showComments.value = true
    }

    watch(showComments, (newValue) => {
      context.emit('comment-toggle', newValue)
    })

    return {
      commentRef,
      showComments,
      toggleComments
    }
  },

  data() {
    return {
      newCommentText: '',
      showDone: false
    }
  },
  computed: {
    comments: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.$emit('update:modelValue', val)
      }
    },
    totalGroups() {
      return Object.keys(this.groups).length
    },
    totalComments() {
      return this.comments.length
    },
    groups() {
      const groups = this.comments.reduce((acc, curr) => {
        if (!acc[curr.position]) acc[curr.position] = []
        acc[curr.position].push(curr)
        return acc
      }, {})

      return groups
    },
    doneGroups() {
      const doneGroups = {}
      Object.keys(this.groups).forEach((pos) => {
        if (this.groups[pos][0].done) {
          doneGroups[pos] = this.groups[pos]
        }
      })
      return doneGroups
    },
    totalDoneGroups() {
      return Object.keys(this.doneGroups).length
    },
    listGroups() {
      if (this.showDone) {
        return this.groups
      }

      const listGroups = {}
      Object.keys(this.groups).forEach((pos) => {
        if (!this.groups[pos][0].done) {
          listGroups[pos] = this.groups[pos]
        }
      })
      return listGroups
    }
  },
  methods: {
    async addComment() {
      const comment = {
        comment_text: this.newCommentText
      }

      const addCommentResponse = await handleApiError(() => documentApi.elementAddComment(
        this.document.id,
        this.document.bc_document_rev_id,
        this.element.bc_document_rev_id
          ? this.element.id
          : this.element.from__bc_document_data_rev_id, // comments in revisions vs pusblished document
        comment
      ))
      this.newCommentText = ''
      this.comments.push(addCommentResponse.data)
    },
    focusTextarea() {
      this.$nextTick(() => {
        this.$refs.newCommentTextRef.focus()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.TooltipBubble {
  @apply bg-white shadow-lg border-gray-100 rounded p-2 px-4 mb-3;
  //@apply hidden;

  &--Show {
    @apply block;
  }
}

.NoComments {
  @apply invisible;
}

.TooltipBubbleWrapper {
  //@apply absolute lg:right-0 lg:top-0 pt-14 sm:right-60 sm:top-0;
  @apply absolute  top-0 lg:right-0 pt-16 /*sm:right-60 sm:top-0;*/;
  $width: 280px;
  $offset: $width - 20px;
  width: $width;
  transform: translateX($offset);
  //border: 2px solid lime;
  right: 268px;

  // Pro telefony a nejspodnejsi prvek
  @media (max-width: 700px) {
    min-height: 500px;
  }

  @screen lg {
    right: 0;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.bounce-enter-active {
  animation: bounce-in 0.3s;
}
.bounce-leave-active {
  animation: bounce-in 0.3s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
</style>
